import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import type { FeatureKey, PermissionAction } from '../lib/permissions';

interface CanProps {
  feature: FeatureKey;
  action?: PermissionAction;
  /** Conteúdo alternativo quando não há permissão. Padrão: nada. */
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Renderiza os filhos apenas se o perfil da sessão tiver a permissão.
 *
 * Esconder o controle é conveniência de interface, não segurança — o
 * `PermissionsGuard` recusa a chamada de qualquer forma. Serve para não
 * oferecer ao usuário uma ação que vai falhar.
 */
export const Can: React.FC<CanProps> = ({ feature, action = 'view', fallback = null, children }) => {
  const { can } = usePermissions();
  return <>{can(feature, action) ? children : fallback}</>;
};
